import { DreamFAQs } from "@portal/app/_components/home/DreamFAQs";
import { styled } from "@mui/material/styles";
import { HomepageHeaderTypography } from "@portal/app/HomePage";

export const HomeFAQSection = () => (
  <Section>
    <HomepageHeaderTypography className="title">Common questions</HomepageHeaderTypography>
    <DreamFAQs />
  </Section>
);

const Section = styled("section")`
  padding: 5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 50rem !important;

  .title {
    margin-bottom: 2.5rem;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 2.5rem 1rem;

    .title {
      margin-bottom: 1.75rem;
    }
  }
`;
